<template>
	<div>
		<div class="vertical_related">
            <div class="list_related_vertical">
                <div class="item_news item_news_vertical"  v-for="(data, index) in tipsNewsData" :key="index">
                    <div class="box-cards">
                        <div class="card-image thumbnail-90" :style="{ backgroundImage: 'url(' + data.image_medium + ')' }">
                            <img :src="data.image_medium" @error="data.image_medium = cdn_url+'/assets/community/images/default.jpg'" />
                        </div>
                    </div>
                    <div class="wrap-card-text">
                        <div class="card-content">
                            <div>
                                <div class="card-label-sharing flex">
                                    <div class="wrap-label flex flex-center">
                                        <span><img :src="cdn_url+'/assets/community/images/icon_calendar.png'" alt="calendar" /></span>
                                        <p class="tx-grey date-post">
                                            {{ data.date }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <h3 class="tx-black card-title">
                                    <a :href="data.detail_url_web" @click="gtmTrackerEngagement(data, index)">
                                        {{ data.title }}
                                    </a>
                                </h3>
                            </div>
                            <div class="card-desc">
                                {{
                                    data.club
                                        ? data.club.name
                                        : data.domain
                                        ? data.domain
                                        : "N/A"
                                }}</div>
                            <div class="share_row_ver">
                                <div
                                    class="btn-share"
                                    :id="'btn-share-'+index"
                                    :ref="'btn-share-'+index"
                                >
                                    <div class="shares">
                                        <ShareNetwork
                                            network="facebook"
                                            @open="gtmTrackerShare(data,'Article Share', data.title, 'Facebook', 1,
                                            'https://facebook.com/sharer/sharer.php?u='+ data.detail_url_web + '&title=' + data.title + '&description=' + data.summary)"
                                            :url="data.detail_url_web"
                                            :title="data.title"
                                            :description="data.summary"
                                        >
                                        <i class="ion-social-facebook"></i>
                                        </ShareNetwork>
                                        <ShareNetwork
                                            network="twitter"
                                            @open="gtmTrackerShare(data,'Article Share', data.title, 'Twitter', 2,
                                            'https://twitter.com/intent/tweet?text='+ data.title +'&url='+ data.detail_url_web)"
                                            :url="data.detail_url_web"
                                            :title="data.title"
                                            :description="data.summary"
                                        >
                                        <i class="ion-social-twitter"></i>
                                        </ShareNetwork>
                                        <ShareNetwork
                                            network="whatsapp"
                                            @open="gtmTrackerShare(data,'Article Share', data.title, 'Whatsapp', 3,
                                                        'https://api.whatsapp.com/send?text='+ data.title + data.detail_url_web)"
                                            :url="data.detail_url_web"
                                            :title="data.title"
                                            :description="data.summary"
                                        >
                                        <i class="ion-social-whatsapp"></i>
                                        </ShareNetwork>
                                    </div>
                                    <a @click="showShare('btn-share-'+index)" class="sharebtn"
                                        ><span
                                            ><i
                                                class="ion-android-share-alt"
                                            ></i></span
                                    ></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div><!--end.item_news-->
            </div>

            <div class="row-button" v-if="nextUrl">
                <a @click="loadMore()" class="seeMore">See More</a>
            </div>
            <!-- <div class="pagination">
                <Pagination></Pagination>
            </div> -->


		</div>
	</div>
</template>
<script>
    import { isMobile } from 'mobile-device-detect';
    import Pagination from "../../widget/Pagination";
    export default {
        props:['endpoint','newsSection'],
        components: {
            Pagination
        },

        data() {
            return {
                cdn_url: cdn_url,
                base_url:base_url,
                app_url:app_url,
                api_url:api_url,
                show: false,
                mobile: false,
                tlength: 25,
                tipsNewsResponse: null,
                tipsNewsData: [],
                nextUrl:null,
                url: api_url+"/news"
            }
        },
        created() {
            this.mobile = isMobile;
            this.getTipsNews();
        },
        methods:{
            gtmTrackerShare(data,gtmevent, title, lable, position, url) {
                // var track = {
                //     'event': 'articleEngagement',
                //     'eventDetail.category': 'Article Engagement',
                //     'eventDetail.action': 'Article Share',
                //     'eventDetail.label': lable,
                //     'position': position,
                //     'title': title,
                //     'articleId': data.id,
                //     'articlePublishedDate': data.date,
                //     'articleAuthor': data.domain,
                //     'destinationPageUrl': url,
                //     'articleList': this.newsSection,
                // };
                const track = {
                    'event': 'articleShare',
                    'eventDetail.category': 'Custom Event',
                    'eventDetail.action': 'Article Share',
                    'eventDetail.label': title,// exp= 'Hadir Dengan Warna Baru, New Honda PCX160 Tampil Makin Mewah'
                    'position': position,
                    'pageUrlPlatform': lable,
                    'destinationPageUrl': url,
                }

                // console.log(track);
                dataLayer.push(track)
            },
            gtmTrackerEngagement(data, index) {
                // console.log(data)
                const track = {
                    'event': 'articleEngagement',
                    'eventDetail.category': 'Article Engagement',
                    'eventDetail.action': 'Click Selengkapnya',
                    'eventDetail.label': data.title,
                    'articleId': data.id,
                    'articlePublishedDate': data.date,
                    'articleAuthor': data.club ? data.club : data.domain ? data.domain : "N/A",
                    'articleList': this.newsSection,
                    'section': this.newsSection,
                    'destinationPageURL': data.detail_url_web,
                    'position': index + 1
                }
                // console.log(track)
                dataLayer.push(track)
            },
            gtmTrackerSeemore() {
                const track = {
                    'event': 'seeMore',
                    'eventDetail.category': 'Custom Event',
                    'eventDetail.action': 'See More Detail',
                    'eventDetail.label': window.location.href,
                    'list': `${this.newsSection} list`,
                }
                dataLayer.push(track)
            },
            showShare(element) {
                if(element){
                    let classList = this.$refs[element][0].classList;
                    if (classList.value.includes("active")) {
                        classList.remove('active');
                    } else{
                        classList.add('active');
                    }
                } else {
                    this.show = !this.show;
                }
            },
            loadMore(){
                this.endpoint = this.nextUrl;
                this.getTipsNews();
                this.gtmTrackerSeemore();
            },
            getTipsNews() {
                axios
                    .get(this.endpoint)
                    .then(res => {
                        // console.log(res);
                        if (res.status == 200) {
                            if (res?.data?.status) {
                                const data = res?.data?.data;
                                if (data) {
                                    this.tipsNewsResponse = data;
                                    this.tipsNewsData.push(...data?.tipsNews);
                                    this.nextUrl = data?.nextPageUrl;
                                }
                                // for (let i = 0; i < data?.tipsNews.length; i++) {
                                //     this.tipsNewsData.push(data?.tipsNews[i]);
                                // }
                            }
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
            }
        }
    }


</script>
<style scoped lang="scss">
    .wrap-label {
    	justify-content:start
    }
    .wrap-label span{
        font-size: 12px;
        font-weight: 500;
        display: inline-block;
        margin-right: 10px;
    }
    .date-news span,
    .date-news p{
        display:inline-block;
    }
    .date-news span{
        font-size:15px;
        margin-right:5px;
    }
    .title-promo{
        margin-bottom: 20px;
            h2{
                margin-top: 0;
        		color:#fff;
        		margin-bottom:20px;
            }
            p{
                margin: 0;
                line-height: 24px;
        		color:#8E8E8E;
            }
    }
    .btn-share{
        position: relative;
    }
    .btn-share{
        margin-left: auto;
    }
    .btn-share a{
    	margin-top:15px;
        border-radius: 100px;
        border: 1px solid rgba(255, 255, 255, 0.2);
        width: 35px;
        height: 35px;
        line-height: 35px;
        text-align: center;
        display: inline-block;
        cursor:pointer;
        color:#fff;
        background-color: transparent;
    }
     .btn-share a:hover{
         background-color: #E61B33;
         color: #fff;
     }
    .active .shares {
        width: 150px;
        left: 42px;
    }
    .active .shares {
        width: 150px;
    }
    .active .sharebtn{
        color: #999;
        background-color: #f2f2f2;
    }
    .shares{
        position: absolute;
        bottom: 0;
        left: 35px;
        height: 35px;
        width:0;
        overflow: hidden;
        -webkit-transition: all 0.3s ease-in-out;
        -moz-transition: all 0.3s ease-in-out;
        -o-transition: all 0.3s ease-in-out;
        -ms-transition: all 0.3s ease-in-out;
        transition: all 0.3s ease-in-out;
        a{
         margin: 0 4px;
        }
    }
    .item_news{
        padding: 0;
    }
    .item_news .shares{
    	right: 42px;
    	left:inherit;
    }
    .card-content{
  		white-space: normal;
    }
    .card-desc{
        margin:0;
    }
    .card-desc p{
        color: #727272;
        font-size: 14px;
        font-weight: 300;
        line-height: 24px;
    }
    .wrap-card-text{
        position: relative;
        padding:0 20px;
        background-color: #1C1C1C;
    }
    .card-title{
        margin: 5px 0;
        font-size: 20px;
            a{
                color: #fff;
                font-size: 20px;
                max-width: 100%;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
            }
    }
    .cta-card-box{
        display:flex;
    }
    .cta-card-box a{
        font-weight: 500;
        display: inline-block;
        padding: 5px 20px;
        font-size: 16px;
        border-radius: 10px;
        border: solid 1px #282828;
        color:#282828;
    }
    .cta-card-box a span{
        color:#E61B33;
    }

    .cta-card-box a
    .box-cards .cta-card-box a span{
        margin-left: 10px;
        font-size: 20px;
    }
    .labelActive {
        position: absolute;
        right: 20px;
        top: 20px;
    }
    .inner-title {
        display: flex;
        align-items: center;
    }
    .box-cards{
        min-width: 150px;
    }
    .card-image{
        margin-bottom: -5px;
        overflow: hidden;
        img {
            width: 100%;
            height: 150px;
            // object-fit: cover;
            opacity: 0;
        }
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        min-width: 150px; height: 150px;
        max-width: 150px;
        background-color: #E61B33;
        border-radius: 8px;
        overflow: hidden;
    }
    .row-button{
        margin-top: 20px;
    }
    .tips_list .row-grid{
        -webkit-flex-wrap: wrap;
        flex-wrap: wrap;
    }
    .tips_list .row-grid .col-grid-50{
        margin-bottom:30px;
    }
    .item_news.item_news_vertical{
        display:flex;
        width: 100%;
        padding:20px 0;
        border-bottom: 1px solid rgba(219,219,219,0.1);
    }
    .item_news.item_news_vertical .wrap-card-text{
        background:transparent;
        width: inherit;
    }
    .item_news.item_news_vertical .wrap-label p{
        margin-bottom:0;
        margin-top:0;
    }
@media all and (max-width:767px){
  .item_news.item_news_vertical{
    align-items: normal;
  }
    .box-cards{
        min-width: 100px;
    }
    .card-image{
        min-width: 100px; height: 100px;
    }
}
</style>
